import React, { useState } from "react";
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../../components/ToggleSwitch.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { updateQueryParams, selectQueryParams } from "../../ui/customerListingReducer.js";

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  const [updateApi] = getApi('updateServiceTypeMapping');
  const [isActive, setIsActive] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedQueryParams = useSelector(selectQueryParams)

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      value: (row) => {
        return <>
          <span className='mx-2'>
            {row.is_active || row.is_active == null ? <FontAwesomeIcon icon={faCircle} className="text-success"/> : <FontAwesomeIcon icon={faCircle} className="text-danger"/>}
          </span>
          {row.id}
        </>
      }
    },
    {
      label: 'User',
      value: (row) => {
        return <div className="d-block">
          <div>({row.user.id})</div>
          <div>{row.user.name}</div>
        </div>
      },
      disableSort: true
    },
    {
      label: 'Service Type',
      value: (row) => {
        return <div className="d-block">
          <div>{row.service_type.name}</div>
          <div>({row.service_type.parent_name})</div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Action',
      value: (row) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_service_type_mapping.name)}>
              <span>
                <ToggleSwitch
                  id={row.id}
                  label_left="Inactive"
                  label_right="Active"
                  onChange={(e) => changeIsActive(e.target.id, e.target.checked)}
                  checked={isActive[row.id] !== undefined ? isActive[row.id] : row.is_active !== false}
                />
              </span>
              <span>
                <button
                  onClick={() => onSubmit(row.id, row.is_active)}
                  className="btn btn-sm border rounded btn-link p-1 mx-2 font-size-12 bg-light">
                  Submit
                </button>
              </span>
            </UiAction>
          </div>
        );
      },
      disableSort: true
    }
  ]

  const changeIsActive = (service_type_mapping_id, activeStatus) => {
    setIsActive(prevState => ({
      ...prevState,
      [service_type_mapping_id]: activeStatus
    }));
  };

  const onSubmit = (service_type_mapping_id, isActiveStatus) => {
    const activeStatus = isActive[service_type_mapping_id] !== undefined ? isActive[service_type_mapping_id] : isActiveStatus !== false;
    updateIsActive({service_type_mapping_id, activeStatus});
  };

  const updateIsActive = async (params) => {
    let parameters = {
      'id' : params.service_type_mapping_id,
      'service_type_user_mapping': {
        'is_active': params.activeStatus
      }
    }
    try{
      let response = await updateApi(parameters).unwrap();
      toast.success(response.message);
      setIsActive({});
      dispatch(updateQueryParams(selectedQueryParams));
    } catch(error){
      toast.error("Something went wrong");
    }
  };

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_service_type_mapping.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Create New Mapping</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate(`/service_type_mapping/new`);
  }

  return <>
    <ListingPageComponent
      key={PAGES.ServiceTypeMappingPage.name}
      uiPage={uiManager.getUiPage(PAGES.ServiceTypeMappingPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Service Type Mapping' }]}
      listingMutation={getApi('serviceTypeMapping')}
      className="service-type-mapping-listing-page"
      contentHeading="Service Type Mapping - Results"
      headers={headers}
      recordsKey="service_type_user_mappings"
      tableHeaderActionsComponent={tableHeaderActionsComponent()}
      searchBy={['ID', 'Name']}
    />
  </>

};

export default Index;
